import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api-base';
import { IUser } from '@cbridge-packages/user';
import { IUserListKey, ITenantUserListKey, IUserListFilter, IUserRemove, IUserRemoveClient } from './userList.interface';

export namespace UserListAction {
  const actionCreator = actionCreatorFactory('UserList');

  export const reload = actionCreator('RELOAD');
  export const loadClient = actionCreator<IUserListKey>('LOAD_CLIENT');
  export const load = actionCreator<ITenantUserListKey>('LOAD');
  export const loadDone = actionCreator<{ list: IUser[] }>('LOAD_DONE');
  export const loadFailed = actionCreator('LOAD_FAILED');
  export const setFilter = actionCreator<IUserListFilter>('SET_FILTER');

  export const remove = actionCreator.async<IUserRemove, void, IApiErrorParams>('REMOVE');
  export const removeClient = actionCreator.async<IUserRemoveClient, void, IApiErrorParams>('REMOVE_CLIENT');

  export const destroy = actionCreator('DESTROY');
}
